declare global {
  interface Window {
    getCkyConsent?: () => ICkyConsent;
  }
}

export interface ICkyCategories {
  advertisement: boolean;
  analytics: boolean;
  functional: boolean;
  necessary: boolean;
  other: boolean;
  performance: boolean;
}

interface ICkyConsent {
  activeLaw: "gdpr" | "ccpa" | string;
  categories: ICkyCategories;
  consentID: string;
  isUserActionCompleted: boolean;
  languageCode: string;
}

let consentPromise: Promise<ICkyConsent> | null = null;
const CKY_TIMEOUT = 3000;

const getDefaultConsentObject = (accepted: boolean): ICkyConsent => {
  return {
    activeLaw: "gdpr",
    categories: {
      advertisement: accepted,
      analytics: accepted,
      functional: accepted,
      necessary: true,
      other: accepted,
      performance: accepted,
    },
    consentID: "",
    isUserActionCompleted: accepted,
    languageCode: "en",
  };
};

export const getConsent = () => {
  if (window.getCkyConsent) {
    return window.getCkyConsent();
  }

  if (consentPromise !== null) {
    return consentPromise;
  }

  consentPromise = new Promise(resolve => {
    if (import.meta.env.MODE === "development") {
      // In development mode CookieYes is not loaded, so we resolve with Accept All consent
      resolve(getDefaultConsentObject(true));
    }

    let timeoutID: number | undefined = undefined;

    document.addEventListener("cookieyes_banner_load", function (eventData) {
      window.clearTimeout(timeoutID);
      const consent = (eventData as CustomEvent<ICkyConsent>).detail;
      resolve(consent);
    });

    timeoutID = window.setTimeout(() => {
      resolve(getDefaultConsentObject(false));
    }, CKY_TIMEOUT);
  });

  return consentPromise;
};
